/**
 * 合作伙伴 / 合作单位 数据
 *
 * 卡片格式参考：http://www.daohuasoft.com/view/customer.html
 *   卡片 = 上方白色 logo 区 + 下方单位名称条（.customer-box / -logo / -name）
 *
 * 字段说明：
 *   name  必填。展示在卡片下方名称条。为保持版面整齐统一使用通称/简称，
 *         各单位工商全称见每家注释，需展示全称时替换即可。
 *   logo  选填。单位 logo，填 require('@/assets/images/partners/xxx.png')。
 *         ★ 留空字符串 '' 时，卡片自动渲染按 type 分类的占位徽章（不显示图片）。
 *   type  必填。占位徽章的图标分类：bank=银行 / hospital=医院 / enterprise=企业平台。
 *         已有 logo 时该字段不影响展示。
 *
 * ⚠ 合规说明（重要，修改前请读）：
 *   1. logo 为空的单位 = 无可用素材或不宜使用，不要随意补图：
 *      - 金融机构行徽属注册商标，未经书面授权不建议使用 → 只展示名称。
 *      - 含中华人民共和国国徽：受《国徽法》约束（国徽不得用于商业广告），
 *        且《广告法》第 9 条禁止变相使用国家机关名义/形象 → 只展示名称。
 *      - 官方仅提供白色版 / 官网已停服：无法取得可用素材 → 只展示名称。
 *   2. 已采用的 logo 均取自各单位官方网站，仍需取得书面使用授权；
 *      未获授权时把 logo 改回 '' 即可降级为纯名称展示（风险显著更低）。
 *   3. 本清单为对外宣传内容，增删前须确认合作关系真实存在，避免构成虚假宣传。
 */

const partnerList = [
  // 中国电信股份有限公司
  {
    name: "中国电信",
    logo: require("@/assets/images/partners/china-telecom.png"),
    type: "enterprise",
  },
  // 中国移动通信集团有限公司
  {
    name: "中国移动",
    logo: require("@/assets/images/partners/china-mobile.png"),
    type: "enterprise",
  },
  // 中国联合网络通信集团有限公司
  {
    name: "中国联通",
    logo: require("@/assets/images/partners/china-unicom.png"),
    type: "enterprise",
  },
  // 中国农业银行股份有限公司 —— logo 取自官网，授权事宜由使用方负责
  {
    name: "农业银行",
    logo: require("@/assets/images/partners/agricultural-bank.png"),
    type: "bank",
  },
  // 中国建设银行股份有限公司 —— logo 取自官网，授权事宜由使用方负责
  {
    name: "建设银行",
    logo: require("@/assets/images/partners/ccb.png"),
    type: "bank",
  },
  // 顺丰速运有限公司（2026-09-10 由"南海网"条目替换；logo 由用户截图提供，授权事宜由使用方负责）
  {
    name: "顺丰速运",
    logo: require("@/assets/images/partners/sf-express.png"),
    type: "enterprise",
  },
  // 数字海南有限公司，官网 www.szhn.cn 未提供高清彩色 logo；
  // 当前使用其 favicon（32×32）放大展示，效果有限，建议后续索取正式授权版
  {
    name: "数字海南",
    logo: require("@/assets/images/partners/digital-hainan.png"),
    type: "enterprise",
  },
  // 海南数字贸易科技服务有限公司
  {
    name: "海南数贸",
    logo: require("@/assets/images/partners/hainan-digital-trade.png"),
    type: "enterprise",
  },
  // 海南省充换电一张网服务有限责任公司
  {
    name: "海南充换电一张网",
    logo: require("@/assets/images/partners/hainan-charging-network.png"),
    type: "enterprise",
  },
  {
    name: "海南放心游",
    logo: require("@/assets/images/partners/hainan-fangxinyou.png"),
    type: "enterprise",
  },
  {
    name: "海南省人民医院",
    logo: require("@/assets/images/partners/hainan-general-hospital.png"),
    type: "hospital",
  },
  // 海南省妇女儿童医学中心 = 海南省妇幼保健院（同一法人，多块牌子，官网 hwcmc.cn）
  {
    name: "海南省妇幼保健院",
    logo: require("@/assets/images/partners/hainan-women-children-medical-center.png"),
    type: "hospital",
  },
  // 海南省中医院＝广东省中医院海南医院（广东省中医院托管后挂牌，同一机构的两个院名）——
  // 2026-09-11 图标由用户提供：绿标「广东省中医院海南医院」+ 暗红标「海南省中医院」两牌上下组合，
  // 即整组标识同属一家单位，不拆成两条客户（原为纯名称展示，官网 SPA 取不到高清院徽）
  {
    name: "海南省中医院",
    logo: require("@/assets/images/partners/hainan-tcm-hospital.png"),
    type: "hospital",
  },
  // 海口市人民医院（海南大学第一附属医院）—— 2026-09-11 换为用户提供的横版组合标识
  // （红色院徽 + 「海口市人民医院 / 海南大学第一附属医院」中英文），旧版仅圆形院徽，
  // 备份 haikou-municipal-hospital.png.bak-0911；授权事宜由使用方负责
  {
    name: "海口市人民医院",
    logo: require("@/assets/images/partners/haikou-municipal-hospital.png"),
    type: "hospital",
  },
  // 三亚市人民医院（四川大学华西三亚医院）—— 2026-09-16 换用官方原版锁标（裁除左侧联合体标识）
  // 来源：用户提供的官方拼版（clipboard-2026-09-16T08-22-06-606Z-db7831e3.jpg，1920×343，白底）。
  //   按列非白密度定位三段：左=「四川大学华西医院|医疗联合体」(x 0..620)、中=蓝底圆形院徽(x 685..1031)、
  //   右=「三亚市人民医院 / 四川大学华西三亚医院」中英文名(x 1104..1919)；
  //   裁除左段，保留中+右官方锁标，去白底→透明 RGBA，tight 裁剪后按高 194px 归一，成品 699×194。
  // 卡片内按「等比缩放衬入统一外接框」渲染（max-width:100% + max-height:60px + object-fit:contain），
  // 本锁标偏宽，自动整体收进框内居中，无需硬改尺寸。
  // 备份：.bak-20260916（原始 149×41 低清）；.bak-20260916-v3（雅黑黑体重建版 792×240，已弃用）；
  //      .bak-20260916-composite554（上一版官网院徽+书法体文字合成版 554×194）。授权事宜由使用方负责
  {
    name: "三亚市人民医院",
    logo: require("@/assets/images/partners/sanya-municipal-hospital.png"),
    type: "hospital",
  },
  // 一龄医院管理集团（AGE DR. HOSPITAL MANAGEMENT GROUP）—— 2026-09-11 由用户提供横版组合标识
  // （左花形标 + 「一龄医院管理集团」+ 英文副标），243×45；授权事宜由使用方负责
  {
    name: "一龄医院管理集团",
    logo: require("@/assets/images/partners/yiling-hospital-management.png"),
    type: "hospital",
  },

  // ===== 预留位 ×6（凑满 22 家 = 每排 11 家；2026-09-11 新增一龄后由 ×7 改为 ×6）=====
  // ⚠ pending: true → 虚线占位卡，老板确认名单后逐个替换 name/type 并删掉 pending 字段
  // ⚠ 交付前若仍未替换，应删除这些预留位（对外页面不可出现"预留位"字样）
  { name: "预留位", logo: "", type: "bank", pending: true },
  { name: "预留位", logo: "", type: "hospital", pending: true },
  { name: "预留位", logo: "", type: "enterprise", pending: true },
  { name: "预留位", logo: "", type: "bank", pending: true },
  { name: "预留位", logo: "", type: "hospital", pending: true },
  { name: "预留位", logo: "", type: "enterprise", pending: true },
];

export default partnerList;



// WEBPACK FOOTER //
// ./src/assets/data/partners.js